import { render, staticRenderFns } from "./SourceSetup.vue?vue&type=template&id=37076d2c&scoped=true&"
import script from "./SourceSetup.vue?vue&type=script&lang=ts&"
export * from "./SourceSetup.vue?vue&type=script&lang=ts&"
import style0 from "./SourceSetup.vue?vue&type=style&index=0&id=37076d2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37076d2c",
  null
  
)

export default component.exports